import * as React from 'react';

import StayDates from './StayDates';
import HotelInfo from './HotelInfo';
import OccupantsInfo from './OccupantsInfo';
import RoomAndOfferInfo from './RoomAndOfferInfo';
import { SelfServiceAPI } from 'types';
import { Box } from '@qga/roo-ui/components';
import HorizontalRuleDesktop from './HorizontalRuleDesktop';
import MobileIcon from './MobileIcon';

const BookingSummary: React.FC<{ booking: SelfServiceAPI.Booking }> = ({ booking }) => {
  return (
    <Box position="relative" pb={[5, 0]} borderBottom={[1, 0]} borderColor="greys.alto" mb={[5, 0]}>
      <MobileIcon />

      <HotelInfo name={booking.reservation.property.name} address={booking.reservation.property.formattedAddressFull} />

      <HorizontalRuleDesktop />

      <StayDates checkIn={booking.reservation.checkIn} checkOut={booking.reservation.checkOut} />

      <HorizontalRuleDesktop />

      <OccupantsInfo
        numberOfAdults={booking.reservation.adults}
        numberOfChildren={booking.reservation.children}
        numberOfInfants={booking.reservation.infants}
      />

      <HorizontalRuleDesktop />

      <RoomAndOfferInfo
        roomType={booking.reservation.roomType.name}
        offer={booking.reservation.offer.name}
        isClassicOffer={booking.reservation.offer.type === 'classic'}
      />
    </Box>
  );
};

export default BookingSummary;
